import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { APP_API_URL } from '../../config/global.config';
import { APP_API_TAGS } from '../app.constants';
import { defaultErrorMsg, defaultHeaders } from '../app.utils';

export const appService = createApi({
  reducerPath: 'api-app',
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: APP_API_URL,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;
        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);
    await defaultErrorMsg(result);

    return result;
  },

  tagTypes: Object.values(APP_API_TAGS),
  keepUnusedDataFor: 10,
  endpoints: () => ({}),
});
